export const openHours = {
  // 08:00
  from: { hour: 8, minute: 0, timeZone: 'Europe/Oslo' },
  // 16:00
  to: { hour: 16, minute: 0, timeZone: 'Europe/Oslo' }
}

/**
 * Gatship contact details shared by the support view and the
 * user-settings Support panel.
 */
export const supportContact = {
  phone: '+4745463920',
  supportEmail: 'support@gatship.com',
  generalEmail: 'post@gatship.com',
  companyName: 'Gatship AS',
  addressLines: ['Porselensvegen 18', 'N-3920 Porsgrunn', 'Norway']
}
